import React from 'react';
import PropTypes from 'prop-types';
import { useFeatureIsOn } from '@growthbook/growthbook-react';

import styles from './legend.module.scss';

const Legend = ({ showAlternativeAvailability, onToggleAlternativeAvailability }) => {
  const isAlternativeAvailabilityEnabled = useFeatureIsOn('alternative-availability');
  console.log('isAlternativeAvailabilityEnabled', isAlternativeAvailabilityEnabled);

  return (
    <div className={styles.wrapper}>
      <div id={styles.existing}>
        <div />
        <p>Existing</p>
      </div>
      <div id={styles.selected}>
        <div />
        <p>Selected</p>
      </div>
      <div id={styles.current}>
        <div />
        <p>Current</p>
      </div>
      {isAlternativeAvailabilityEnabled && (
        <div className={styles.toggleWrapper}>
          <label className={styles.toggle}>
            <input type="checkbox" checked={showAlternativeAvailability} onChange={(e) => onToggleAlternativeAvailability(e.target.checked)} />
            <span className={styles.slider}></span>
            <span className={styles.toggleText}>
              Can&apos;t find a time? See <span className={styles.orangeText}>other coaches&apos;</span> availability
            </span>
          </label>
        </div>
      )}
    </div>
  );
};

Legend.propTypes = {
  showAlternativeAvailability: PropTypes.bool,
  onToggleAlternativeAvailability: PropTypes.func
};

Legend.defaultProps = {
  showAlternativeAvailability: false,
  onToggleAlternativeAvailability: () => {}
};

export default Legend;
